"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var mobx_react_1 = require("mobx-react");

var core_1 = require("@material-ui/core");

var Clear_1 = require("@material-ui/icons/Clear"); // export interface IPantHelpState {
//     heightIFrame: number | 'auto';
// }


function addTimeParams(src) {
  try {
    var url = new URL(src);
    url.searchParams.append('t', Date.now().toString());
    return url.toString();
  } catch (e) {
    return '';
  }
}

var PantHelp = function PantHelp(props) {
  // const [state] = useState<IPantHelpState>({ heightIFrame: 'auto'});
  var _a = props.appState,
      sessState = _a.sessState,
      pantState = _a.pantState;
  var theme = core_1.useTheme();
  var marginTop = pantState.headerHeight || 64;
  var fullScreen = core_1.useMediaQuery(theme.breakpoints.down('xs'));
  var dialogStyle = !fullScreen ? {
    marginTop: marginTop
  } : {};
  var titleStyle = !fullScreen ? {} : {
    marginTop: marginTop
  };
  var iconCloseStyle = !fullScreen ? {
    position: 'absolute',
    top: 8,
    right: 8
  } : {
    position: 'absolute',
    top: 8 + marginTop,
    right: 8
  };
  var dialogContentStyle = {
    padding: 0,
    height: '100vh'
  };

  var handleClose = function handleClose() {
    pantState.goBack();
  };

  var src = addTimeParams(sessState.recurs.RECURLHELP);
  var close = React.createElement(core_1.IconButton, {
    style: iconCloseStyle,
    onClick: handleClose
  }, React.createElement(Clear_1.default, {
    color: "disabled"
  }));
  var title = React.createElement("div", {
    style: titleStyle
  }, React.createElement(core_1.Typography, {
    variant: "h6"
  }, "Ajuda"), close);
  return React.createElement(core_1.Dialog, {
    open: true,
    onClose: handleClose,
    scroll: "paper",
    maxWidth: false,
    fullWidth: true,
    style: dialogStyle,
    fullScreen: fullScreen
  }, React.createElement(core_1.DialogTitle, null, title), React.createElement(core_1.DialogContent, {
    dividers: true,
    style: dialogContentStyle
  }, React.createElement("iframe", {
    src: src,
    style: {
      width: '100%',
      height: '-webkit-fill-available',
      display: 'block',
      border: 'none'
    }
  })), React.createElement(core_1.DialogActions, null, React.createElement(core_1.Button, {
    onClick: handleClose
  }, "Tancar")));
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(PantHelp));